import { Component, OnInit, SimpleChanges, AfterViewInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Constants } from 'src/app/constants/constants';
import { ApiService } from 'src/app/service/api.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { UtilService } from 'src/app/service/util.service';
import { isNullOrUndefined } from 'util';
import { ToastService } from 'src/app/service/toast.service';
import { TransactionDetailComponent } from '../transaction-detail/transaction-detail.component';
import { EnvService } from 'src/app/service/env.service';

@Component({
  selector: 'view-invoice-list',
  templateUrl: './view-invoice-list.component.html',
  styleUrls: ['./view-invoice-list.component.scss']
})
export class ViewInvoiceListComponent implements OnInit, AfterViewInit {

  @Input() invoices: Array<any>;
  @Output() selectedInvoiceEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPaymentStatusEmitter: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('transctionDetailComponent') transctionDetailComponent: TransactionDetailComponent;

  invoiceMasterData: Array<any>;

  sortType = ["DESCENDING", "ASCENDING"];
  columns = ["Invoice No", "Account", "Amount", "invoiceDate", "invoiceSummary.dueDate", "Status"];
  invoiceStatusList: Array<string> = ["DRAFT", "OPEN", "PAID", "OVERDUE", "VOIDED"];
  tableSelectedSortOptions: Array<string>;

  viewInvoice: boolean = false;
  showAutoPaymentMessage: boolean = false;
  selectedInvoice: any;
  accountPaymentSetting: any;
  autoPaymentConfirm: boolean = false;
  paymentInstrument: any;
  confirmationMessage: any;

  showPayment: boolean = false;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService,
    private env: EnvService) { }

  ngOnInit() {
    this.invoiceMasterData = this.invoices.map(x => Object.assign({}, x));
    // this.getAccountPaymentSetting();
    this.setShowPayment();
  }

  ngAfterViewInit(): void {
    // this.invoiceMasterData = this.invoices.map(x => Object.assign({}, x));
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initTableSelectedSortOptions();
    this.prepareUIData();
    this.updateSelectedInvoice();
    // this.getAccountPaymentSetting();
  }

  updateSelectedInvoice() {
    if (this.selectedInvoice != null) {
      var index = this.invoices.findIndex(x => x.invoiceId === this.selectedInvoice.invoiceId);
      if (index != -1) {
        this.selectedInvoice = this.invoices[index];
      }
    }
  }

  onInvoiceSelected(invoice: any) {
    this.getAccountPaymentSetting();
    this.selectedInvoice = invoice;
    this.viewInvoice = true;
    this.selectedInvoiceEmitter.emit(invoice);
  }

  onCloseInvoiceView() {
    this.selectedInvoice = null;
    this.viewInvoice = false;
    this.showAutoPaymentMessage = false;
    // this.closeInvoiceEmitter.emit();
  }

  initTableSelectedSortOptions() {
    this.tableSelectedSortOptions = [this.columns[3], this.sortType[0]];
  }

  prepareUIData() {
    if (this.invoices == null) return;
    this.sortByDate(this.sortType[0], this.columns[3], this.invoices);
  }

  goToPayment() {
    if (this.accountPaymentSetting && this.accountPaymentSetting.paymentInstruments && this.accountPaymentSetting.paymentInstruments.length > 0) {
      document.getElementById("openSavedAccountModal").click();
    } else {
      document.getElementById("openPaymentOptionsModal").click();
    }
  }

  onPaymentOptionBackClick() {
    document.getElementById("closePaymentModal").click();
    document.getElementById("openSavedAccountModal").click();
  }

  getAccountPaymentSetting() {
    this.accountPaymentSetting = null;
    this.utilService.showSpinner();
    this.apiService.getAccountPaymentSetting().then((data) => {
      this.utilService.hideSpinner();
      console.log("account payment setting data::", data);
      this.accountPaymentSetting = data;
      this.isShowAutoPaymentMessage();
      // this.goToPayment();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountPaymentSetting();
        });
      }
      else {
        this.utilService.hideSpinner();
        document.getElementById("openPaymentOptionsModal").click();
        // if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        // else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onAutoPaymentConfimation() {
    this.autoPaymentConfirm = !this.autoPaymentConfirm;
    console.log("Auto payment confirmation checked :  ", this.autoPaymentConfirm);
  }

  onPaymentStatusReceived(data) {
    console.log("Payment status received", data);
    if (!(this.accountPaymentSetting && this.accountPaymentSetting.paymentSetting && this.accountPaymentSetting.paymentSetting == 'AUTO')) {
      if (data.savedInstrument && data.autoPay == 'MANUAL') {
        this.paymentInstrument = data.instrument;
        document.getElementById('openAutoPayModal').click();
      }
    }
    this.onPaymentStatusEmitter.emit();
  }

  confirmAutoPayment() {

    console.log("Auto pay confirmed : ", this.autoPaymentConfirm);
    if(this.autoPaymentConfirm) {
      var payload = {
        "paymentSetting": "AUTO",
        "defaultInstrumentId": null
      } 
      
      if (!this.isDefaultInstrumentExist() && !this.paymentInstrument.isDefault) {
        payload.defaultInstrumentId = this.paymentInstrument.instrumentId;
      }

      this.updateAccountPaymentSetting(payload);
    } else {
      document.getElementById('closeAutoPayModal').click();
    }
  }

  isDefaultInstrumentExist() {

    if(this.accountPaymentSetting && this.accountPaymentSetting.paymentInstruments) {
      this.accountPaymentSetting.paymentInstruments.forEach(instrument => {
        if(instrument.isDefault) {
           return true;
        }
      });
    }
    return false;
  }

  updateAccountPaymentSetting(payload) {
    console.log("Updating payment settings");
    this.utilService.showSpinner();
    this.apiService.updateAccountPaymentSetting(payload).then((data) => {
      this.utilService.hideSpinner();
      this.accountPaymentSetting = data;
      this.showAutoPaymentSuccessMessage(data);
      this.toast.showSuccess("Auto Payment setup completed");
      document.getElementById('closeAutoPayModal').click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.updateAccountPaymentSetting(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  
  showAutoPaymentSuccessMessage(data) {
    
    var message = Constants.PAYMENT_CONFIRMATION_MESSAGE_2 + Constants.AUTO_PAYMENT_DAY_OFFSET + Constants.PAYMENT_CONFIRMATION_MESSAGE_3;
  
    if(data && data.paymentInstruments) {
       for(let instrument of data.paymentInstruments) {
        if(instrument.isDefault) {

          if(instrument.mode == "ACH") {
            this.confirmationMessage = Constants.PAYMENT_CONFIRMATION_MESSAGE_ACH_1 + this.getLastFourDigit(instrument.summary.accountNo) + message;
          } else {
            this.confirmationMessage = Constants.PAYMENT_CONFIRMATION_MESSAGE_CARD_1 + this.getLastFourDigit(instrument.summary.cardNo) + message;
          }
          break;    
        }
      }
    } else {
      this.confirmationMessage = "Auto Payment setup completed";
    }
    
    // Show message
    if(!isNullOrUndefined(this.confirmationMessage))
      document.getElementById("openConfimationMessageModal").click();

  }

  getLastFourDigit(account: string) {
    return account.substr(account.length - 4);
  }

  cancelAutoPayment() {
  }

  showPayNowButton() {
    if (this.selectedInvoice &&
      this.selectedInvoice.invoiceStatus &&
      (this.selectedInvoice.invoiceStatus == this.invoiceStatusList[1] || this.selectedInvoice.invoiceStatus == this.invoiceStatusList[3]) &&
      this.selectedInvoice.invoiceSummary.total > 0) {
      // If Payment not initiated or failed 
      if (isNullOrUndefined(this.selectedInvoice.paymentStatus) || this.selectedInvoice.paymentStatus == 'FAILED' || this.selectedInvoice.paymentStatus == 'DECLINED')
        return true;
    }
    return false;
  }

  // Sorting Logics
  onSortByDateClick(selectedColumn: string) {
    var sortType = this.getSortType(selectedColumn);
    console.log("sortType::", sortType);
    this.sortByDate(sortType, selectedColumn, this.invoices);
    this.tableSelectedSortOptions[0] = selectedColumn;
    this.tableSelectedSortOptions[1] = sortType;
  }

  getSortType(selectedColumn: string) {
    var selectedSortType = this.tableSelectedSortOptions[1];
    var lastSelectedSortColumn = this.tableSelectedSortOptions[0];
    if (lastSelectedSortColumn == selectedColumn) {
      if (selectedSortType == this.sortType[0]) {
        selectedSortType = this.sortType[1];
      } else {
        selectedSortType = this.sortType[0];
      }
    }
    return selectedSortType == null ? this.sortType[0] : selectedSortType;
  }

  sortStringVal(sortType: string, fieldName: string, invoices) {
    let that = this;
    invoices = invoices.sort(function (a, b) {
      var val1 = "";
      var val2 = "";
      if (a[fieldName] != undefined && a[fieldName] != null) {
        val1 = a[fieldName].toLowerCase();
      }
      if (b[fieldName] != undefined && b[fieldName] != null) {
        val2 = b[fieldName].toLowerCase();
      }
      if (sortType == that.sortType[0]) {
        if (val1 < val2) return -1;
        if (val1 > val2) return 1;
        return 0;
      } else {
        if (val1 > val2) return -1;
        if (val1 < val2) return 1;
        return 0;
      }
    });
  }

  sortByDate(sortType: string, fieldName: string, invoices) {
    let that = this;
    invoices = invoices.sort(function (a, b) {
      if (sortType == that.sortType[0]) {
        return <any>new Date(b[fieldName]) - <any>new Date(a[fieldName]);
      } else {
        return <any>new Date(a[fieldName]) - <any>new Date(b[fieldName]);
      }
    });
  }

  getAutoPaymentDate() {
    return (this.selectedInvoice.invoiceSummary.dueDate - Constants.AUTO_PAYMENT_DATE_OFFSET)
  }

  isShowAutoPaymentMessage() {

    if (this.selectedInvoice &&
      this.selectedInvoice.invoiceStatus &&
      this.selectedInvoice.invoiceStatus == this.invoiceStatusList[1] &&
      this.accountPaymentSetting.paymentSetting == 'AUTO')
      this.showAutoPaymentMessage = true;
    else
      this.showAutoPaymentMessage = false;
  }

  setShowPayment() {
    this.showPayment = this.env.SHOW_PAYMENT;
  }

}
